import { QueryClient } from '@tanstack/vue-query'
import { Ref, ref } from 'vue'
import LaborService from '@/services/LaborService'
import { Labor } from '@/models/labor'

export default function useGetAllLabor() {
  const queryClient = new QueryClient()
  const data: Ref<Labor[]> = ref(null)
  const error = ref(null)
  const laborService = new LaborService()

  queryClient.fetchQuery({
    queryKey: ['labors'],
    queryFn: async () => {
      const data = await laborService.all()
      
      // create a detail cache for each item
      data.forEach((item) => {
        queryClient.setQueryData(['labor', item.id], item)
      })

      return data
    }
  }).then((response) => {
    data.value = response
  }).catch((err) => { 
    error.value = err
  })

  return { data, error }
}